import React from "react";
import { Modal } from "react-bootstrap";
import { Collapse, Card } from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import RegistrationsAction from "../../../../../store/registrations/action";
import RegistrationsService from "../../../RegistrationsService";
import _ from "lodash";
import RegistrantsMembersList from "../../RegistrantsMembersList";
import $ from "jquery";
import ReviewRequestQuestions from "./ReviewRequestQuestions";
import formatEventDates, { EventDates } from "../../../formatEventDates";
import {
  CompositionModalMode,
  RegisTableType,
  RegistrationStatuses,
  getRegistrationStatusesOptions,
  ReviewRequestActions,
} from "../../../Helpers/LookUpValues";
import { toast } from "react-toastify";
import CompositionModal from "../../../../AdvanceSearch/SavedSearches/CompositionModal";
import MailGunEmailTypes from "../../../../Email/Enums/MailGunEmailTypes";
import MailGunEmailActions from "../../../../../store/mailgunEmails/action";
import MailGunMembersListModal from "../../../../Shared/MailGunMembersListModal";
import InstructorsMembersList from "../../InstructorsMembersList";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import "../../../registration.css";
import { bool } from "yup";
import AuthService from "../../../../Auth/AuthService";
import PermissionFeature from "../../../../Permissions/PermissionFeature";

const filter = createFilterOptions();

class ReviewRegistrationRequestsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      detailsAccOpen: true,
      registraintsAccOpen: true,
      registrants: [],
      filteredRegistrants: [],
      instructors: [],
      selectedRegistrationIds: [],
      selectedWaitlistIds: [],
      showQuestionsModal: false,
      showCompositionModal: false,
      compositionModalMode: "",
      composeModalEmails: [],
      composeModalPhoneNos: [],
      showConfigEmailMembersModal: false,
      selectedInstrIds: [],
      regisStatusesOptions: getRegistrationStatusesOptions(),
    };
  }
  onShow = async () => {
    const { props } = this;

    // The modal instance is never unmounted, but the lists inside it are, so the
    // checkboxes come back empty on reopen while these ids survive. Clear them to
    // match, otherwise a stale selection from the previous open gets submitted.
    // The status filter is reset for the same reason: the registrant lists below
    // are refetched unfiltered, so leaving old ticks in the dropdown would show a
    // filter that is not actually applied.
    this.setState({
      selectedRegistrationIds: [],
      selectedWaitlistIds: [],
      selectedInstrIds: [],
      regisStatusesOptions: getRegistrationStatusesOptions(),
    });

    const { result: data = {} } =
      (await RegistrationsService.GetChildTemplateRegistrants(
        props.clickedChildTemplateId
      )) || {};

    //console.log(data);
    if (!_.isEmpty(data)) {
      await this.setState({
        registrants: data,
        isloading: false,
        filteredRegistrants: data,
      });
    } else {
      this.setState({
        registrants: [],
        filteredRegistrants: [],
        isloading: false,
      });
    }
    {
      const { result: data = {} } =
        (await RegistrationsService.GetChildTemplateInstructors(
          props.clickedChildTemplateId
        )) || {};
      //console.log(data);
      if (!_.isEmpty(data)) {
        await this.setState({
          instructors: data,
          isloading: false,
        });
      } else {
        this.setState({
          instructors: [],
          isloading: false,
        });
      }
    }

    const { location } = this.props;
    const searchParams = new URLSearchParams(location.search);
    const filterId = searchParams.get("showEmailConfigModal");
    // Check if the query parameter showEmailConfig is true
    if (filterId) {
      this.showConfigEmailModal();
    }
  };
  showSpinner = () => {
    $(".loading").show();
  };

  hideSpinner = () => {
    $(".loading").hide();
  };
  /// Gets the Questions with choosen Answers
  getRegistrantQuestions = async (row) => {
    await RegistrationsService.GetOccasionRegQuestionsWithAnswers(
      this.props.clickedChildTemplateId, //occasionId,
      row.registrationId
    )
      .then((data) => {
        if (data.statusCode == 200) {
          let questionsResponse = data.result;
          this.props.setRegistrationQuestions(questionsResponse);
          this.setState({
            showQuestionsModal: true,
          });
          this.hideSpinner();
        } else {
          this.hideSpinner();
        }
      })
      .catch((error) => {
        this.hideSpinner();
      });
  };
  handleSubmitModal = async (btnAction, registrationIds, listName) => {
    // Selection-based actions operate on the passed ids, defaulting to the
    // Registrants-list selection. Promotion from the Waitlist list passes its
    // own selection explicitly. The two lists hold independent selections, so
    // the empty-selection warning names the one it means.
    //
    // The "...and Others" pair is guarded alongside the plain buttons: the
    // server derives their "others" set itself, so submitting them with nothing
    // ticked is not a no-op but a class-wide deny (or approve), emails included.
    // ApproveAll/DenyAll are deliberately absent -- they act on every pending
    // member in the class by design and need no selection at all.
    const ids =
      registrationIds !== undefined
        ? registrationIds
        : this.state.selectedRegistrationIds;
    const selectionActions = [
      ReviewRequestActions.Approve,
      ReviewRequestActions.Deny,
      ReviewRequestActions.Waitlist,
      ReviewRequestActions.ApproveAndDenyOthers,
      ReviewRequestActions.DenyAndApproveOthers,
    ];
    if (selectionActions.includes(btnAction) && _.isEmpty(ids)) {
      toast.warn(
        `Please select at least one member from the ${
          listName || "Registrants"
        } list.`
      );
      return;
    }
    // Several actions refuse rows the server will not touch. Two different
    // rules, same shape, so they share one block:
    //
    //  - Waitlist wants members who still want a seat (Pending Approval, or
    //    Registered and giving it back).
    //  - Approve and Deny -- and the ticked half of the two "...and Others"
    //    items -- must not overwrite an attendance outcome. status is a single
    //    column with no history, so approving or denying an Attended row
    //    destroys the only record that the member turned up, and in the Approve
    //    case does it silently because approval sends no email.
    //
    // The list shows settled rows on purpose (export, contact) and their
    // checkboxes are live, so one stray tick beside a genuine pending row was
    // enough to lose it. The server drops these rows either way, but it drops
    // them without a word, so name what is being skipped before the request
    // goes out -- and refuse outright when nothing eligible is left, because an
    // empty change set comes back from the API as "Something went wrong".
    const attendanceRecorded = (r) =>
      r.registrationStatusId === RegistrationStatuses.Attended ||
      r.registrationStatusId === RegistrationStatuses.NoShow;
    const skipRules = {
      [ReviewRequestActions.Waitlist]: {
        isSkipped: (r) =>
          r.registrationStatusId !== RegistrationStatuses.PendingApproval &&
          r.registrationStatusId !== RegistrationStatuses.Registered,
        noneEligible:
          "Only members who are Pending Approval or Registered can be moved to the waitlist.",
        someSkipped: (skipped, total, movable) =>
          `${skipped} of the ${total} selected members have already been marked ` +
          `Attended, No Show or Not Accepted and will be left as they are. ` +
          `Move the other ${movable} to the waitlist?`,
      },
      [ReviewRequestActions.Approve]: {
        isSkipped: attendanceRecorded,
        noneEligible:
          "Members already marked Attended or No Show cannot be approved -- it would overwrite the attendance record.",
        someSkipped: (skipped, total, movable) =>
          `${skipped} of the ${total} selected members have already been marked ` +
          `Attended or No Show. Approving them would overwrite that record, so ` +
          `they will be left as they are. Approve the other ${movable}?`,
      },
      [ReviewRequestActions.Deny]: {
        isSkipped: attendanceRecorded,
        noneEligible:
          "Members already marked Attended or No Show cannot be denied -- it would overwrite the attendance record.",
        someSkipped: (skipped, total, movable) =>
          `${skipped} of the ${total} selected members have already been marked ` +
          `Attended or No Show. Denying them would overwrite that record and email ` +
          `them a denial, so they will be left as they are. Deny the other ${movable}?`,
      },
    };
    // The "...and Others" pair applies the same rule to its ticked half; the
    // "others" half is derived server-side from pending rows only.
    skipRules[ReviewRequestActions.ApproveAndDenyOthers] =
      skipRules[ReviewRequestActions.Approve];
    skipRules[ReviewRequestActions.DenyAndApproveOthers] =
      skipRules[ReviewRequestActions.Deny];

    const rule = skipRules[btnAction];
    if (rule) {
      const skipped = (this.state.registrants || []).filter(
        (r) => ids.includes(r.registrationId) && rule.isSkipped(r)
      );
      if (skipped.length === ids.length) {
        toast.warn(rule.noneEligible);
        return;
      }
      if (skipped.length > 0) {
        const movable = ids.length - skipped.length;
        const proceed = window.confirm(
          rule.someSkipped(skipped.length, ids.length, movable)
        );
        if (!proceed) {
          return;
        }
      }
    }
    // The class-wide actions take no selection, so nothing on screen shows who
    // they are about to hit -- the status filter may even be hiding all of it --
    // and Deny All emails every one of them. Confirm with the count first.
    // window.confirm is how the rest of the app asks (Users, Directory, Saved
    // Searches). The count comes from `registrants`, which is the unfiltered
    // list for this class, so it matches the server's own target set.
    const classWideConfirms = {
      [ReviewRequestActions.ApproveAll]: (who) =>
        `Approve ${who} still awaiting approval for this class?`,
      [ReviewRequestActions.DenyAll]: (who) =>
        `Deny ${who} still awaiting approval for this class? Each of them is emailed.`,
    };
    const buildConfirm = classWideConfirms[btnAction];
    if (buildConfirm) {
      const pendingCount = (this.state.registrants || []).filter(
        (r) => r.registrationStatusId == RegistrationStatuses.PendingApproval
      ).length;
      const who = `all ${pendingCount} member${pendingCount === 1 ? "" : "s"}`;
      if (!window.confirm(buildConfirm(who))) {
        return;
      }
    }
    let formData = {
      childTemplateId: this.props.clickedChildTemplateId,
      registrationIds: ids,
      action: btnAction,
    };
    const data = await RegistrationsService.ReviewRequest(formData);
    if (!_.isEmpty(data) && data.status == "Success") {
      toast.success("Request has been Reviewed Successfully.");
      this.props.onClose(); // Hide the Modal
    } else {
      toast.error("Something went wrong");
    }
  };
  setSelectedRegistrationIds = (selectedIds) => {
    this.setState({
      selectedRegistrationIds: selectedIds,
    });
  };
  setSelectedWaitlistIds = (selectedIds) => {
    this.setState({
      selectedWaitlistIds: selectedIds,
    });
  };
  setSelectedInstrIds = (selectedIds) => {
    this.setState({
      selectedInstrIds: selectedIds,
    });
  };
  showCompositionModal = async (mode) => {
    const { clickedChildTemplateRow } = this.props;
    const {
      instructors,
      selectedInstrIds,
      selectedRegistrationIds,
      registrants,
    } = this.state;
    ///****************  Email Icon Clicked****************************/
    if (mode == CompositionModalMode.Email) {
      if (
        clickedChildTemplateRow.emailAlias &&
        _.isEmpty(selectedRegistrationIds)
      ) {
        let { response = [] } =
          (await RegistrationsService.GetMailingListSubsribersEmailAddresses(
            clickedChildTemplateRow.emailAlias
          )) || {};
        debugger;
        if (!_.isEmpty(response)) {
          await this.setState({
            composeModalEmails: response,
          });
        } else {
          this.setState({
            composeModalEmails: [],
          });
        }
      } else if (!_.isEmpty(selectedRegistrationIds)) {
        //If checkboxes are selected for Registrant Accordion..
        let regisEmails = registrants
          .filter((i) => selectedRegistrationIds.includes(i.registrationId))
          .map((m) => m.email);
        let instrEmails = instructors
          .filter((i) => selectedInstrIds.includes(i.id))
          .map((m) => m.email);
        let allEmails = [...regisEmails, ...instrEmails];
        this.setState({
          composeModalEmails: allEmails,
        });
      }
    } ///****************  SMS Icon Clicked****************************/
    else if (mode == CompositionModalMode.SMS) {
      let validRegisPhoneNo = true;
      let validInstrPhonNo = true;
      let instrPhoneNos = instructors
        .filter(
          (i) =>
            selectedInstrIds.includes(i.id) &&
            !_.isEmpty(i.phoneNo) &&
            i.phoneNo != "N/A" //N/A => Not allowed to text alerts, setting in Profile.
        )
        .map((m) => m.phoneNo);
      let regisPhoneNos = registrants
        .filter(
          (i) =>
            selectedRegistrationIds.includes(i.registrationId) &&
            !_.isEmpty(i.phoneNo) &&
            i.phoneNo != "N/A" //N/A => Not allowed to text alerts, setting in Profile.
        )
        .map((m) => m.phoneNo);
      let allPhoneNos = [...instrPhoneNos, ...regisPhoneNos];
      if (_.isEmpty(selectedRegistrationIds) && _.isEmpty(selectedInstrIds)) {
        toast.warn("Please Select Members.");
        return;
      }
      if (_.isEmpty(allPhoneNos)) {
        toast.warn("Selected Member(s) doesn't have valid Phone Number(s).");
        return;
      }
      this.setState({
        composeModalPhoneNos: allPhoneNos,
      });

      if (!_.isEmpty(selectedInstrIds) && _.isEmpty(instrPhoneNos)) {
        // For Instructors
        var everyPhoneNA = instructors
          .filter((i) => selectedInstrIds.includes(i.id))
          .every((e) => e.phoneNo == "N/A");
        var everyPhoneInvalid = instructors
          .filter((i) => selectedInstrIds.includes(i.id))
          .every((e) => _.isEmpty(e.phoneNo));
        if (everyPhoneNA) {
          toast.warn(
            "Selected Instructor(s) are not allowed to have text alerts."
          );
        }
        if (everyPhoneInvalid) {
          toast.warn("Selected Instructor(s) doesn't have valid Phone No.");
        }
        //return //=> commented because there could be valid Registrants below code
        validInstrPhonNo = false;
      }
      if (!_.isEmpty(selectedRegistrationIds) && _.isEmpty(regisPhoneNos)) {
        // For Registrants
        var everyPhoneNA = registrants
          .filter((i) => selectedRegistrationIds.includes(i.registrationId))
          .every((e) => e.phoneNo == "N/A");
        var everyPhoneInvalid = registrants
          .filter((i) => selectedRegistrationIds.includes(i.registrationId))
          .every((e) => _.isEmpty(e.phoneNo));
        if (everyPhoneNA) {
          toast.warn(
            "Selected Registrants(s) are not allowed to have text alerts."
          );
        }
        if (everyPhoneInvalid) {
          toast.warn("Selected Registrants(s) doesn't have valid Phone No.");
        }
        validRegisPhoneNo = false;
      }

      if (!validInstrPhonNo && !everyPhoneNA) {
        return; //Don't show Modal
      }
    }

    this.setState({
      showCompositionModal: true,
      compositionModalMode: mode,
    });
  };
  hideCompositionModel = () => {
    this.setState({
      showCompositionModal: false,
    });
  };
  hideConfigEmailModal = () => {
    this.setState({
      showConfigEmailMembersModal: false,
    });
  };
  closeReviewRequestModal = () => {
    this.props.onClose();
  };
  showConfigEmailModal = () => {
    this.setState({
      showConfigEmailMembersModal: true,
    });
  };
  onDeleteEmailList = async () => {
    await this.props.getPendingApprovalRegistrations();
  };
  ///Change Handler for Status
  selectStatus = async (value) => {
    // Rebuild the options immutably: the array came from a shared module-level
    // constant, and writing `checked` through it leaked the filter into every
    // other consumer.
    const selectedIds = (value || []).map((v) => v.id);
    const regisStatusesOptions = this.state.regisStatusesOptions.map(
      (option) => ({
        ...option,
        checked: selectedIds.includes(option.id),
      })
    );
    this.setState({ regisStatusesOptions });
    this.filterRegistrants(regisStatusesOptions.filter((o) => o.checked));
  };
  filterRegistrants = (allChecked) => {
    let { registrants = [] } = this.state;
    if (allChecked.length > 0) {
      let filteredRecords = registrants.filter((reg) => {
        if (
          allChecked.some(
            (checkedRegis) => checkedRegis.id == reg.registrationStatusId
          )
        ) {
          return reg;
        }
      });
      this.setState({ filteredRegistrants: filteredRecords });
    } else {
      this.setState({ filteredRegistrants: registrants });
    }
  };
  render() {
    const { props } = this;
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const { clickedChildTemplateRow } = this.props;
    let { regisStatusesOptions } = this.state;

    const selectedStatuses =
      regisStatusesOptions.length > 0
        ? regisStatusesOptions.filter((f) => f.checked)
        : [];

    // Partition into the main Registrants list (never shows waitlisted rows,
    // respects the status filter) and a separate Waitlist list (always the full
    // waitlist set, independent of the filter dropdown).
    const waitlistRegistrants = this.state.registrants.filter(
      (r) => r.registrationStatusId === RegistrationStatuses.Waitlist
    );
    const mainRegistrants = this.state.filteredRegistrants.filter(
      (r) => r.registrationStatusId !== RegistrationStatuses.Waitlist
    );
    const hasPending = this.state.registrants.some(
      (s) => s.registrationStatusId == RegistrationStatuses.PendingApproval
    );
    const hasRegistered = this.state.registrants.some(
      (s) => s.registrationStatusId == RegistrationStatuses.Registered
    );
    const hasWaitlisted = waitlistRegistrants.length > 0;
    // A registrant can be waitlisted if they are pending or already registered.
    const canWaitlist = hasPending || hasRegistered;
    const waitlistBtnStyle = {
      backgroundColor: "#d39e00",
      borderColor: "#d39e00",
      color: "#fff",
    };
    return (
      <>
        <Modal
          className="modal fade team-style"
          id="reviewRegRequestsModal"
          size="xl"
          backdrop="static"
          show={props.showModal}
          centered
          onShow={this.onShow}
          onHide={props.onClose}
        >
          <Modal.Header className="modal-header bg-secondary py-2" closeButton>
            <Modal.Title className=" w-100 modal-title font-italic">
              <div className="feModalHeader align-items-center text-uppercase d-flex">
                <div className="col-sm-6 mt-2">
                  <h5 className="text-white mt-0">
                    Review Registration Request
                  </h5>
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="modal-body reviewRegRequestBody">
            {/* ///First Accordion of Registration Details/// */}
            <div className="row">
              <div className="col">
                <Card className="mb-1">
                  <h6
                    className="card-header bg-primary text-white mb-3 mt-0 cursorPointer"
                    onClick={() => {
                      this.setState({
                        detailsAccOpen: !this.state.detailsAccOpen,
                      });
                    }}
                  >
                    <i class="fa fa-address-card" aria-hidden="true" />{" "}
                    Registration Details
                  </h6>

                  <Collapse isOpen={this.state.detailsAccOpen}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="col-md-6">
                          <span className="mb-1 h6 font-weight-normal text-secondary d-block">
                            <small>Title</small>
                          </span>
                          <b className="h5 text-secondary d-block">
                            {clickedChildTemplateRow.title}
                          </b>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="col-md-6">
                          <span className="mb-1 h6 font-weight-normal text-secondary d-block">
                            <small> Dates</small>
                          </span>
                          <b className="h5 text-secondary d-block">
                            <EventDates row={clickedChildTemplateRow} />
                          </b>

                          <span className="mb-1 h6 font-weight-normal text-secondary d-block">
                            <small> Registration Window</small>
                          </span>
                          <b className="h5 text-secondary d-block">
                            {clickedChildTemplateRow.registrationWindow}
                          </b>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="col-md-6">
                          <span className="mb-1 h6 font-weight-normal text-secondary d-block">
                            <small> Location</small>
                          </span>
                          <b className="h5 text-secondary d-block">
                            {clickedChildTemplateRow.location}
                          </b>
                        </div>
                        <div className="col-md-6">
                          <span className="mb-1 h6 font-weight-normal text-secondary d-block">
                            <small> Category</small>
                          </span>
                          <b className="h5 text-secondary d-block">
                            {clickedChildTemplateRow.category}
                          </b>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </Card>
              </div>
            </div>
            {/* // Filter Dropdown && Actions Icons for EMail Config,SMS// */}
            <div className="regisMems">
              <div className="row p-1 regisMemActs">
                <div className="col-6 mb-2">
                  <Autocomplete
                    //loading={this.state.loadingOptions}
                    multiple
                    limitTags={2}
                    id="statusFilter"
                    options={regisStatusesOptions}
                    size="small"
                    disableCloseOnSelect
                    //filterOptions={(options, state) => options}
                    autoHighlight={true}
                    getOptionLabel={(option) => {
                      if (option != undefined) {
                        return option.status;
                      } else {
                        return "";
                      }
                    }}
                    getOptionSelected={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(e, value, reason, details) => {
                      this.selectStatus(value, reason, details);
                    }}
                    // For searching options inside the client's array
                    // filterOptions={(options, params) => {
                    //   const inputValue = params.inputValue || "";
                    //   if (inputValue !== "") {
                    //     //when there is no space in search text
                    //     if (/^[a-zA-Z-]*$/.test(inputValue)) {
                    //       //if it is alphabets
                    //       let result = options.filter((val, ind, arr) => {
                    //         return val.status
                    //           .toLowerCase()
                    //           .includes(inputValue.toLowerCase());
                    //       });
                    //       return result;
                    //     } else if (!isNaN(inputValue) && isFinite(inputValue)) {
                    //       return [];
                    //     }
                    //   }
                    //   const filtered = filter(options, params);

                    //   return filtered;
                    // }}
                    value={selectedStatuses}
                    renderOption={(option, { selected }) => (
                      <React.Fragment>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selectedStatuses.some(
                            (s) => s.id == option.id
                          )}
                        />
                        {option.status}
                      </React.Fragment>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Filter Statuses"
                        placeholder="Select Status"
                      />
                    )}
                  />
                </div>
                <div className="col-6 d-flex justify-content-end align-items-center">
                  <React.Fragment>
                    <UncontrolledDropdown className="inline-item facility-filter">
                      <DropdownToggle tag="a" className="nav-link-font-size">
                        <i className={"fas fa-cog"} title={`Customization`}></i>
                      </DropdownToggle>
                      <DropdownMenu className="dropdown-menu-body">
                        {!clickedChildTemplateRow.isMailingListExists
                          ? AuthService.canAdd(
                              PermissionFeature.EmailListAdmin
                            ) && (
                              <DropdownItem
                                className="dropdown-item-custom"
                                onClick={this.showConfigEmailModal}
                              >
                                <i className="fas fa-pencil-alt ffi"></i>
                                Create Email List
                              </DropdownItem>
                            )
                          : AuthService.canView(
                              PermissionFeature.EmailListAdmin
                            ) ||
                            AuthService.canUpdate(
                              PermissionFeature.EmailListAdmin
                            )(
                              <DropdownItem
                                className="dropdown-item-custom"
                                onClick={this.showConfigEmailModal}
                              >
                                <i className="fas fa-pencil-alt ffi"></i>
                                Configure Email List
                              </DropdownItem>
                            )}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </React.Fragment>
                  {
                    <i
                      className="csvIconSize fas fa-envelope pl-1"
                      onClick={() =>
                        this.showCompositionModal(CompositionModalMode.Email)
                      }
                      //title={`Send email to members ${this.state.data.length}`}
                    ></i>
                  }

                  <i
                    className="csvIconSize fas fa-sms pl-1"
                    onClick={() =>
                      this.showCompositionModal(CompositionModalMode.SMS)
                    }
                    title="Send SMS to members"
                  ></i>
                </div>
              </div>
              {/* ///Second Accordion Members (Registrants + Instructors) */}
              <div className="row">
                <div className="col-12">
                  <Card className="mb-1">
                    <h6
                      className="card-header bg-primary text-white mb-3 mt-0 cursorPointer"
                      onClick={() => {
                        this.setState({
                          registraintsAccOpen: !this.state.registraintsAccOpen,
                        });
                      }}
                    >
                      {/* Members which have requested for an Occasion Registration */}
                      <i className="fa fa-users" aria-hidden="true" /> Members
                    </h6>
                    {/* ***************************************Call for Members List(Registrants) Component************************************* */}
                    <Collapse isOpen={this.state.registraintsAccOpen}>
                      <div className="col-12">
                        <RegistrantsMembersList
                          listData={mainRegistrants}
                          //reloadRegistrations={this.reloadRegistrations}
                          isloading={this.state.isloading}
                          getRegistrantQuestions={this.getRegistrantQuestions}
                          setSelectedRegistrationIds={
                            this.setSelectedRegistrationIds
                          }
                          registrantTableType={RegisTableType.ReviewRequest}
                          caption={"Registrants"}
                          childTemplateId={this.props.clickedChildTemplateId}
                          registrationTitle={
                            clickedChildTemplateRow
                              ? clickedChildTemplateRow.title
                              : ""
                          }
                          registrationWindow={
                            clickedChildTemplateRow
                              ? formatEventDates(clickedChildTemplateRow)
                              : ""
                          }
                        />
                        {/* ***** Separate Waitlist list (only when someone is waitlisted) ***** */}
                        {hasWaitlisted && (
                          <>
                            <RegistrantsMembersList
                              listData={waitlistRegistrants}
                              isloading={this.state.isloading}
                              getRegistrantQuestions={
                                this.getRegistrantQuestions
                              }
                              setSelectedRegistrationIds={
                                this.setSelectedWaitlistIds
                              }
                              registrantTableType={RegisTableType.ReviewRequest}
                              caption={"Waitlist"}
                              childTemplateId={
                                this.props.clickedChildTemplateId
                              }
                              registrationTitle={
                                clickedChildTemplateRow
                                  ? clickedChildTemplateRow.title
                                  : ""
                              }
                              registrationWindow={
                                clickedChildTemplateRow
                                  ? formatEventDates(clickedChildTemplateRow)
                                  : ""
                              }
                            />
                            {/* Promote a waitlisted person back to Registered (reuses Approve) */}
                            <div className="text-right mb-2">
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={() =>
                                  this.handleSubmitModal(
                                    ReviewRequestActions.Approve,
                                    this.state.selectedWaitlistIds,
                                    "Waitlist"
                                  )
                                }
                              >
                                Move to Registered
                              </button>
                            </div>
                          </>
                        )}
                        {/* How to handle Instructors */}
                        <InstructorsMembersList
                          listData={this.state.instructors}
                          //reloadRegistrations={this.reloadRegistrations}
                          isloading={this.state.isloading}
                          setSelectedInstrIds={this.setSelectedInstrIds}
                          registrationTitle={
                            clickedChildTemplateRow
                              ? clickedChildTemplateRow.title
                              : ""
                          }
                          registrationWindow={
                            clickedChildTemplateRow
                              ? formatEventDates(clickedChildTemplateRow)
                              : ""
                          }
                        />
                      </div>
                    </Collapse>
                  </Card>
                </div>
              </div>
            </div>
          </Modal.Body>
          <div className="card-footer text-center border-top-0">
            {(hasPending || canWaitlist) && (
              <>
                {hasPending && (
                <>
                <div className="btn-group">
                  <button
                    type="button"
                    onClick={() =>
                      this.handleSubmitModal(ReviewRequestActions.Approve)
                    }
                    className="btn btn-success pr-1"
                    title="Approves the members ticked in the Registrants list. Nobody else is changed."
                  >
                    Approve Selected {/* Main Button */}
                  </button>
                  <button
                    type="button"
                    className="btn btn-success dropdown-toggle dropdown-toggle-split"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span className="sr-only">Toggle Dropdown</span>{" "}
                    {/* Hidden*/}
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() =>
                        this.handleSubmitModal(ReviewRequestActions.ApproveAll)
                      }
                      title="Approves every member in this class who is still awaiting approval, whether ticked or not. Members already approved, attended or marked no show are left alone."
                    >
                      Approve All Pending {/* Child Button */}
                    </a>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() =>
                        this.handleSubmitModal(
                          ReviewRequestActions.ApproveAndDenyOthers
                        )
                      }
                      title="Approves the ticked members and denies everyone else still awaiting approval, who are emailed. Members already approved, attended or marked no show are left alone."
                    >
                      Approve Selected, Deny Other Pending {/* Child Button */}
                    </a>
                  </div>
                </div>
                <div className="btn-group">
                  <button
                    type="button"
                    onClick={() =>
                      this.handleSubmitModal(ReviewRequestActions.Deny)
                    }
                    class="btn btn-danger ml-1"
                    title="Denies the members ticked in the Registrants list, who are emailed. Nobody else is changed."
                  >
                    Deny Selected {/* Main Button */}
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger dropdown-toggle dropdown-toggle-split"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span className="sr-only">Toggle Dropdown</span>{" "}
                    {/* Hidden*/}
                  </button>
                  <div className="dropdown-menu dropdown-menu-right">
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() =>
                        this.handleSubmitModal(ReviewRequestActions.DenyAll)
                      }
                      title="Denies every member in this class who is still awaiting approval, whether ticked or not, and emails each of them. Members already approved, attended or marked no show are left alone."
                    >
                      Deny All Pending {/* Child Button */}
                    </a>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() =>
                        this.handleSubmitModal(
                          ReviewRequestActions.DenyAndApproveOthers
                        )
                      }
                      title="Denies the ticked members, who are emailed, and approves everyone else still awaiting approval. Members already approved, attended or marked no show are left alone."
                    >
                      Deny Selected, Approve Other Pending {/* Child Button */}
                    </a>
                  </div>
                </div>
                </>
                )}
                {canWaitlist && (
                  <button
                    type="button"
                    onClick={() =>
                      this.handleSubmitModal(ReviewRequestActions.Waitlist)
                    }
                    className="btn ml-1"
                    style={waitlistBtnStyle}
                  >
                    Move to Waitlist
                  </button>
                )}
              </>
            )}

            <button
              type="button"
              className="btn btn-primary ml-1 cancelModal"
              onClick={props.onClose}
            >
              Close
            </button>
          </div>
          {/* For showing the Questions Answered by the Registrants during making a Registration Request */}
          <ReviewRequestQuestions
            showModal={this.state.showQuestionsModal}
            onClose={() =>
              this.setState({
                showQuestionsModal: false,
              })
            }
          />
          {/* Used for Modal of SMS and Emails */}
          <CompositionModal
            showModal={this.state.showCompositionModal}
            onClose={this.hideCompositionModel}
            check={this.state.compositionModalMode}
            //addresses={this.state.emails}
            addresses={
              this.state.compositionModalMode == CompositionModalMode.Email
                ? [
                    ...(this.state.composeModalEmails || []),
                    ...(this.props.melstate.addtlMemEmails || []),
                  ]
                : this.state.composeModalPhoneNos // Phone Numbers
            }
            listType={MailGunEmailTypes.Registrants}
            entityId={this.props.clickedChildTemplateId}
            getAdditionalSubsribersEmailAddresses={
              this.props.getAdditionalSubsribersEmailAddresses
            }
            isSaveSearchFacilityCS={false}
            isBucketFilled={
              !_.isEmpty(JSON.parse(localStorage.getItem("BucketSearch")))
            }
            isFRTCS={false}
          />
        </Modal>
        {/********Email List Config Modal********/}
        <MailGunMembersListModal
          showModal={this.state.showConfigEmailMembersModal}
          onModalClose={this.hideConfigEmailModal}
          mgListAddress={clickedChildTemplateRow.mgListAddress}
          childTemplateAbbr={
            clickedChildTemplateRow.abbreviation &&
            clickedChildTemplateRow.abbreviation
          }
          TeamCheck={true}
          FacilityId={null}
          isFacility={false}
          ChildTemplateId={this.props.clickedChildTemplateId}
          isRegistration={true}
          MailGunEmailType={MailGunEmailTypes.Registrants}
          emailListId={clickedChildTemplateRow.emailListId}
          onDeleteEmailList={this.onDeleteEmailList}
          closeReviewRequestModal={this.closeReviewRequestModal}
        ></MailGunMembersListModal>
      </>
    );
  }
}
export default withRouter(
  connect(
    (state) => ({
      registrationsState: state.registrations,
      melstate: state.mailGunEmail,
    }),
    {
      ...RegistrationsAction,
      ...MailGunEmailActions,
    }
  )(ReviewRegistrationRequestsModal)
);
